"use client";

import * as React from "react";
import { addDays, format } from "date-fns";
import { Calendar as CalendarIcon } from "lucide-react";
import { DateRange } from "react-day-picker";

import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

interface IDatePickerWithRangeProps
  extends React.HTMLAttributes<HTMLDivElement> {
  defaultFrom?: Date;
  defaultTo?: Date;
  onDateRangeChanged: (date: DateRange | undefined) => void;
}
export function DatePickerWithRange({
  className,
  onDateRangeChanged,
  defaultFrom,
  defaultTo,
}: IDatePickerWithRangeProps) {
  const [date, setDate] = React.useState<DateRange | undefined>({
    from: defaultFrom,
    to: defaultTo,
  });
  const [dateChanged, setDateChanged] = React.useState(false);

  return (
    <div className={cn("grid gap-2 rounded-md", className)}>
      <Popover
        onOpenChange={(open) => {
          if (dateChanged) {
            onDateRangeChanged?.(date);
            setDateChanged(false);
          }
        }}
      >
        <PopoverTrigger asChild>
          <Button
            id="date"
            variant={"outline"}
            className={cn(
              "justify-start text-left font-normal",
              !date && "text-muted-foreground",
              date && "text-foreground",
            )}
          >
            <CalendarIcon className="mr-2 h-4 w-4" />
            {date?.from ? (
              date.to ? (
                <>
                  {format(date.from, "dd/MM/y")} - {format(date.to, "dd/MM/y")}
                </>
              ) : (
                format(date.from, "dd/MM/y")
              )
            ) : (
              <span>Pick a date</span>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar
            initialFocus
            mode="range"
            defaultMonth={date?.from}
            selected={date}
            onSelect={(range) => {
              setDate(range);
              setDateChanged(true);
            }}
            numberOfMonths={2}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
}
